const robotoWeights = {
  thin: {
    includeFontPadding: false,
    fontFamily: "sans-serif-thin",
    fontWeight: "normal",
    backgroundColor: "transparent"
  },
  light: {
    includeFontPadding: false,
    fontFamily: "sans-serif-light",
    fontWeight: "normal",
    backgroundColor: "transparent"
  },
  regular: {
    includeFontPadding: false,
    fontFamily: "sans-serif",
    fontWeight: "normal",
    backgroundColor: "transparent"
  },
  medium: {
    includeFontPadding: false,
    fontFamily: "sans-serif-medium",
    fontWeight: "normal",
    backgroundColor: "transparent"
  },
  bold: {
    includeFontPadding: false,
    fontFamily: "sans-serif",
    fontWeight: "bold",
    backgroundColor: "transparent"
  },
  condensed: {
    includeFontPadding: false,
    fontFamily: "sans-serif-condensed",
    fontWeight: "normal",
    backgroundColor: "transparent"
  },
  condensedBold: {
    includeFontPadding: false,
    fontFamily: "sans-serif-condensed",
    fontWeight: "bold",
    backgroundColor: "transparent"
  }
};

export default robotoWeights;
